import { useQuery } from '@powersync/react';
import { Navigate } from '@tanstack/react-router';

import { queries, type SidebarViewRow } from '@flow/sync';

import { t } from '../i18n/es.js';
import { useSession } from '../session.jsx';
import { viewHref } from '../shell/sections.js';

/**
 * `/` opens the first view of the sidebar (Inbox in GTD+PARA), read from the user's installed
 * views rather than hard-coded, so another template opens its own first view.
 */
export function IndexRedirect() {
  const { user } = useSession();
  const query = queries.sidebarViews(user?.id ?? '');
  const { data, isLoading } = useQuery<SidebarViewRow>(query.sql, query.params);
  const first = data.find((view) => view.sidebar_section && view.key);
  if (first?.key) return <Navigate to={viewHref(first.key)} replace />;
  // Still syncing the user's views: nothing to redirect to yet.
  return <p className="muted">{isLoading ? t.app.loading : t.sync.firstSync}</p>;
}
